import { _request } from 'common/helpers/api';
export const getMeetingData = (organisation, room_name) => {
    return _request('/vmeet/meeting_data.json', 'GET', {
        queryParams: {
            room_name,
            organisation,
        },
    });
};
